import NewFolder from '~components/new-chat/folder'

export default NewFolder
